interface IProps {
    size?: number;
}
export const WarningIcon = (props: IProps) => {
    const { size } = props;
    const defaultSize = "49";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || defaultSize}
            height={size || defaultSize}
            viewBox="0 0 49 49"
            fill="none"
        >
            <path
                d="M24.5 0.875C11.4414 0.875 0.875 11.4423 0.875 24.5C0.875 37.5586 11.4423 48.125 24.5 48.125C37.5586 48.125 48.125 37.5577 48.125 24.5C48.125 11.4414 37.5577 0.875 24.5 0.875ZM24.5 44.4336C13.4818 44.4336 4.56641 35.5175 4.56641 24.5C4.56641 13.4818 13.4825 4.56641 24.5 4.56641C35.5182 4.56641 44.4336 13.4825 44.4336 24.5C44.4336 35.5182 35.5175 44.4336 24.5 44.4336Z"
                fill="#9B9B9B"
            />
            <path
                d="M24.5 12.7683C23.4806 12.7683 22.6543 13.5946 22.6543 14.614V26.4997C22.6543 27.5191 23.4806 28.3454 24.5 28.3454C25.5194 28.3454 26.3457 27.5191 26.3457 26.4997V14.614C26.3457 13.5946 25.5194 12.7683 24.5 12.7683Z"
                fill="#9B9B9B"
            />
            <path
                d="M24.5 35.589C25.8761 35.589 26.9917 34.4734 26.9917 33.0973C26.9917 31.7212 25.8761 30.6056 24.5 30.6056C23.1239 30.6056 22.0083 31.7212 22.0083 33.0973C22.0083 34.4734 23.1239 35.589 24.5 35.589Z"
                fill="#9B9B9B"
            />
        </svg>
    );
};
